import { SlotType, createSlotType } from '../models/slot-type.model';

export const SLOT_TYPES = {
  MainHand: createSlotType('mainhand', 'Main Hand'),
  OffHand: createSlotType('offhand', 'Off Hand'),
  Head: createSlotType('head', 'Head'),
  Armor: createSlotType('armor', 'Armor'),
  Shoes: createSlotType('shoes', 'Shoes'),
  Bag: createSlotType('bag', 'Bag'),
  Cape: createSlotType('cape', 'Cape'),
  Mount: createSlotType('mount', 'Mount'),
  Potion: createSlotType('potion', 'Potion'),
  Food: createSlotType('food', 'Food'),
};

export function getAllSlotTypes(): SlotType[] {
  return Object.values(SLOT_TYPES);
}

export function getSlotTypeByName(name: string | undefined): SlotType | undefined {
  if (!name) {
    return undefined;
  }
  return getAllSlotTypes().find((slotType) => slotType.name === name);
}
